export { Highlight } from './highlight';
export type { HighlightProps } from './highlight';
